import { render, staticRenderFns } from "./lang-select.vue?vue&type=template&id=2f360b0e&"
import script from "./lang-select.vue?vue&type=script&lang=ts&"
export * from "./lang-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports